<div class="onboarding-management">

    <div class="page-header">
        <h2 class="page-title">Onboarding Actions</h2>
        <button nz-button nzType="primary" (click)="openCreateModal()">
            <span nz-icon nzType="plus" nzTheme="outline"></span>
            Create New Action
        </button>
    </div>

    <nz-card class="table-card">
        
        <nz-table #actionItemsTable [nzData]="actionItems" [nzLoading]="loading" [nzFrontPagination]="false"
            [nzShowSizeChanger]="false" nzBordered>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Bucket</th>
                    <th>Status</th>
                    <th>Created By</th>
                    <th>Created At</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let card of actionItemsTable.data">
                    <td><strong>{{ card.name | titlecase }}</strong></td>
                    <td>{{ card.bucket | titlecase }}</td>
                    <td>
                        <nz-tag [nzColor]="card.status === 'active' ? 'green' : 'default'">
                            {{ card.status | titlecase }}
                        </nz-tag>
                    </td>
                    <td>{{ card.createdby }}</td>
                    <td>{{ card.created_date | date }} </td>
                    <td class="actions-cell">
                        <button nz-button nzType="default" nzSize="small" (click)="openEditModal(card)">
                            <span nz-icon nzType="edit" nzTheme="outline"></span>
                            Edit
                        </button>
                    </td>
                </tr>
            </tbody>
        </nz-table>

    </nz-card>

</div>


<nz-modal [(nzVisible)]="actionsModal" nzTitle="The first Modal" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
    <ng-container *nzModalContent>
        <form [formGroup]="actionsForm">
            <nz-form-item>
                <nz-form-label nzRequired>Action Name</nz-form-label>
                <nz-form-control>
                    <input nz-input formControlName="name" placeholder="Action name" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzRequired>Action Description</nz-form-label>
                <nz-form-control>
                    <textarea nz-input formControlName="description" placeholder="Description of your action"></textarea>
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzRequired>Onboarding Bucket</nz-form-label>
                <nz-form-control>
                    <nz-select formControlName="bucket" nzPlaceHolder="Select Bucket" class="full-width-select">
                        <nz-option *ngFor="let b of buckets" [nzValue]="b.id" [nzLabel]="b.name | titlecase"></nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzRequired>Action Type</nz-form-label>
                <nz-form-control>
                    <nz-select formControlName="type" nzPlaceHolder="Select Type" class="full-width-select">
                        <nz-option nzValue="Ops Action" nzLabel="Ops Action"></nz-option>
                        <nz-option nzValue="Rep Action" nzLabel="Rep Action"></nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
            <nz-form-item *ngIf="actionsForm.get('id')?.value">
                <nz-form-label nzRequired>Status</nz-form-label>
                <nz-form-control>
                    <nz-select formControlName="status" class="full-width-select">
                        <nz-option nzValue="active" nzLabel="Active"></nz-option>
                        <nz-option nzValue="inactive" nzLabel="Inactive"></nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </form>
    </ng-container>
</nz-modal>
